import { ProductType } from '../../../models/ProductType';
import { ProductTypeCahnge } from './reducers';

export const changeProductType = (productType: ProductType | null): ProductTypeCahnge => ({
    type: 'PRODUCT_TYPE_CHANGE',
    payload: productType
});
